import { Container } from "@mui/material";

const SizeGuide = () => {
  return (
    <div className="pt-24 pb-16 bg-gray-50 min-h-screen mt-8">
      <Container maxWidth="md">
        
        <h1 className="text-3xl md:text-4xl font-semibold mb-6 text-center">
          Size Guide
        </h1>

        <p className="text-gray-600 text-center mb-10">
          Please refer to the size chart below to find your perfect fit.
        </p>

        {/* SIZE TABLE */}
        <div className="overflow-x-auto bg-white shadow-md rounded-xl">
          <table className="w-full text-left border-collapse">
            <thead className="bg-black text-white">
              <tr>
                <th className="p-4">Size</th>
                <th className="p-4">Chest (inches)</th>
                <th className="p-4">Waist (inches)</th>
                <th className="p-4">Hip (inches)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="p-4">S</td>
                <td className="p-4">36-38</td>
                <td className="p-4">30-32</td>
                <td className="p-4">36-38</td>
              </tr>
              <tr className="border-b bg-gray-50">
                <td className="p-4">M</td>
                <td className="p-4">38-40</td>
                <td className="p-4">32-34</td>
                <td className="p-4">38-40</td>
              </tr>
              <tr className="border-b">
                <td className="p-4">L</td>
                <td className="p-4">40-42</td>
                <td className="p-4">34-36</td>
                <td className="p-4">40-42</td>
              </tr>
              <tr className="border-b bg-gray-50">
                <td className="p-4">XL</td>
                <td className="p-4">42-44</td>
                <td className="p-4">36-38</td>
                <td className="p-4">42-44</td>
              </tr>
              <tr>
                <td className="p-4">XXL</td>
                <td className="p-4">44-46</td>
                <td className="p-4">38-40</td>
                <td className="p-4">44-46</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* NOTE */}
        <div className="mt-8 text-gray-600 text-sm text-center">
          <p>
            * Measurements may vary slightly depending on the product style.
          </p>
        </div>

      </Container>
    </div>
  );
};

export default SizeGuide;